<template>
  <VBtn icon="mdi-trash-can-outline" color="error" variant="text" density="compact" v-bind="$attrs" />
</template>
